// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__34Xrr","tab":"ProcedureTabs_tab__15zCZ"};